import { render, staticRenderFns } from "./mod-09.vue?vue&type=template&id=40b3eadc&scoped=true&"
import script from "./mod-09.vue?vue&type=script&lang=js&"
export * from "./mod-09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3eadc",
  null
  
)

export default component.exports